// Footer.js
import React, { useState } from 'react';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import '../Styles/Footer.css';

const Footer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <footer className="footer">
            <p>© 2025 Cyphr Systems</p>
            <button className="privacy-button" onClick={openModal}>
                Privacy Policy
            </button>
            <PrivacyPolicyModal isOpen={isModalOpen} onClose={closeModal} />
        </footer>
    );
};

export default Footer;
